import INSIGHTS_URLS from "./urls";

export default [
  {
    appTitle: true,
    header: "Insights Studio",
    icon: "fa-kit fa-hdp-app-insights-studio",
    baseRoute: INSIGHTS_URLS.baseUrl,
  },
  {
    header: "Analytic Tools",
    children: [
      {
        name: "Population Builder",
        route: INSIGHTS_URLS.POPULATION_BUILDER,
        permissions: ["population.view_population"],
      },
      {
        name: "Metric Builder",
        route: INSIGHTS_URLS.METRIC_BUILDER,
        permissions: ["metric.view_metric"],
      },
    ],
  },
  {
    header: "Cohorts (Legacy)",
    children: [
      {
        name: "Cohort Groups",
        route: INSIGHTS_URLS.COHORT_GROUPS,
        permissions: ["cohort.view_group"],
      },
      {
        name: "Simple Cohorts",
        route: INSIGHTS_URLS.COHORT_SIMPLE_RULES,
        permissions: ["cohort.view_simplecohort"],
      },
      {
        name: "Complex Cohorts",
        route: INSIGHTS_URLS.COHORT_COMPLEX_RULES,
        permissions: ["cohort.view_complexcohort"],
      },
    ],
  },
  {
    header: "BI Workspace",
    children: [
      {
        name: "Dashboard Manager",
        route: INSIGHTS_URLS.DASHBOARD_MANAGER,
        permissions: ["sisense.change_dashboard"],
      },
      {
        name: "Data Model",
        route: INSIGHTS_URLS.DATA_CONSOLE,
        permissions: ["sisense.view_data_console"],
      },
      {
        name: "Analytics",
        route: INSIGHTS_URLS.ANALYTICS_CONSOLE,
        permissions: ["sisense.view_analytic_console"],
      },
      {
        name: "SQL Notebook",
        route: INSIGHTS_URLS.NOTEBOOKS_CONSOLE,
        permissions: ["sisense.view_notebook_console"],
      },
    ],
  },
];
